export const CONSENT_COOKIE_NAME = 'consentCookie'
export const CONSENT_COOKIE_DEFAULTS = {
  functional: true,
  targeting: true,
  performance: true,
  isSet: false,
}
